function setSuppliers(data) {
	return {
		type: 'GET_SUPPLIERS',
		payload: data,
	};
}

export { setSuppliers };
